
<div class="loader" [ngClass]="{'loader': lang_loading == 'es','loader-english': lang_loading == 'en' }" >
</div>
